module.exports = __webpack_public_path__ + "img/edit_icon.9a4d5fd5.svg";